import { render, staticRenderFns } from "./ConfigureSign.vue?vue&type=template&id=51b9c433&"
import script from "./ConfigureSign.vue?vue&type=script&lang=js&"
export * from "./ConfigureSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b9c433')) {
      api.createRecord('51b9c433', component.options)
    } else {
      api.reload('51b9c433', component.options)
    }
    module.hot.accept("./ConfigureSign.vue?vue&type=template&id=51b9c433&", function () {
      api.rerender('51b9c433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/febos/ConfigureSign.vue"
export default component.exports